// extracted by mini-css-extract-plugin
export default {"box":"StornoButton_box__IRUDP","compact":"StornoButton_compact__PzSom","storno":"StornoButton_storno__4OTP-","yes":"StornoButton_yes__e2IxK","no":"StornoButton_no__FHGWM"};